import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { onMounted, ref } from "@vue/runtime-dom";
import loadScript from "load-script";

const GOOGLE_SDK_URL = "https://apis.google.com/js/api.js";


export default /*@__PURE__*/_defineComponent({
  __name: 'DropZoneGoogleDrive',
  props: {
    clientId: {
        type: String,
        required: true,
    },
    developerKey: {
        type: String,
        required: false,
    },
    scope: {
        type: Array<String>,
        default: () => {
            return ["https://www.googleapis.com/auth/drive.readonly"];
        },
    },
    viewId: {
        type: String,
        default: "DOCS",
    },
    origin: {
        type: String,
    },
    createPicker: {
        type: Function,
    },
    authImmediate: {
        type: Boolean,
        default: false,
    },
    multiselect: {
        type: Boolean,
        default: false,
    },
    navHidden: {
        type: Boolean,
        default: false,
    },
    upload: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    mimeTypes: {
        type: Array,
    },
},
  emits: ["change", "loaded", "cancel", "picked", "authenticated"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

onMounted(() => {
    if (isGoogleReady()) {
        // google api is already exists
        // init immediately
        onApiLoad();
    } else if (!scriptLoadingStarted.value) {
        // load google api and the init
        scriptLoadingStarted.value = true;
        loadScript(GOOGLE_SDK_URL, onApiLoad);
    } else {
        // is loading
    }
});

const scriptLoadingStarted = ref<boolean>(false);

const isGoogleReady = () => {
    return !!window["gapi"];
};

const isGoogleAuthReady = () => {
    return !!window["gapi"]["auth"];
};

const isGooglePickerReady = () => {
    return !!window["google"]["picker"];
};

const onApiLoad = () => {
    window["gapi"].load("auth");
    window["gapi"].load("picker");
};

const doAuth = (callback) => {
    window["gapi"]["auth"].authorize(
        {
            client_id: props.clientId,
            scope: props.scope,
            immediate: props.authImmediate,
        },
        callback,
    );
};

const onChoose = () => {
    if (!isGoogleReady() || !isGoogleAuthReady() || !isGooglePickerReady() || props.disabled) {
        return;
    }

    const token = window["gapi"]["auth"].getToken();
    const oauthToken = token && token.access_token;

    if (oauthToken) {
        defaultCreatePicker(oauthToken);
    } else {
        doAuth(({ access_token }) => defaultCreatePicker(access_token));
    }
};

const pickerCallback = (data) => {
    emit("change", data);

    switch (data.action) {
        case "loaded":
            emit("loaded");
            break;
        case "cancel":
            emit("cancel");
            break;
        case "picked":
            emit("picked", data.docs);
            break;
        default:
            break;
    }
};

const onAuthenticated = (authResult) => {
    emit("authenticated", authResult);
};

const defaultCreatePicker = (oauthToken) => {
    onAuthenticated(oauthToken);

    if (props.createPicker) {
        return props.createPicker(window["google"], oauthToken);
    }

    const googleViewId = window["google"]["picker"].ViewId[props.viewId];
    const view = new window["google"]["picker"].View(googleViewId);

    if (props.mimeTypes) {
        view.setMimeTypes(props.mimeTypes.join(","));
    }

    if (!view) {
        throw new Error("Can't find view by viewId");
    }

    const picker = new window["google"]["picker"].PickerBuilder()
        .addView(view)
        .setOAuthToken(oauthToken)
        .setDeveloperKey(props.developerKey)
        .setCallback(pickerCallback);

    if (origin) {
        picker.setOrigin(origin);
    }

    if (props.navHidden) {
        picker.enableFeature(window["google"]["picker"].Feature.NAV_HIDDEN);
    }

    if (props.multiselect) {
        picker.enableFeature(window["google"]["picker"].Feature.MULTISELECT_ENABLED);
    }

    if (props.upload) {
        picker.addView(new window["google"]["picker"].DocsUploadView());
    }

    picker.build().setVisible(true);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { onClick: onChoose }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      (!this.$slots.default)
        ? (_openBlock(), _createElementBlock("button", _hoisted_1, "Open google chooser"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})